import {
  ClinicType,
  FeedFilterType,
  FeedTypeEnum,
  ImportFilterType,
  InvoiceFilterType,
  LeadFilterType,
  MessagesFilterType,
  PatientFilterType,
  PatientsJourneysFilterType,
  ProposalFilterType,
} from '@/types'

import { PROPOSAL_DEFAULT_STATUSES } from './proposal'

export const CLINIC_FILTERS_KEY = 'clinic_filter_01'
export const FEEDS_FILTERS_KEY = 'feeds_filter_01'
export const PATIENT_FEEDS_FILTERS_KEY = 'patient_feeds_filters_01'
export const MESSAGES_FILTERS_KEY = 'messages_filters'
export const PATIENTS_FILTERS_KEY = 'patient_filter_01'
export const PATIENTS_SUGGESTIONS_FILTERS_KEY = 'patient_suggestions_filter'
export const LEADS_FILTERS_KEY = 'lead_filter_01'
export const PATIENT_JOURNEY_FILTERS_KEY = 'patient_journey_filter_04'
export const PJ_SUGGESTIONS_FILTERS_KEY = 'pj_suggestions_filter_01'
export const IMPORT_FILTERS_KEY = 'import_filter_01'
export const INVOICE_FILTERS_KEY = 'invoice_filter_02'
export const PROPOSAL_FILTERS_KEY = 'proposal_filter_01'
export const PATIENT_INVOICE_FILTERS_KEY = 'patient_invoice_filter_02'
export const FAQ_FILTERS_KEY = 'faq_filters'
export const TEMPLATE_FILTERS_KEY = 'template_filter_01'

export const FILTERS_KEYS = [
  CLINIC_FILTERS_KEY,
  FEEDS_FILTERS_KEY,
  PATIENT_FEEDS_FILTERS_KEY,
  MESSAGES_FILTERS_KEY,
  PATIENTS_FILTERS_KEY,
  PATIENTS_SUGGESTIONS_FILTERS_KEY,
  LEADS_FILTERS_KEY,
  PATIENT_JOURNEY_FILTERS_KEY,
  PJ_SUGGESTIONS_FILTERS_KEY,
  IMPORT_FILTERS_KEY,
  INVOICE_FILTERS_KEY,
  PROPOSAL_FILTERS_KEY,
  PATIENT_INVOICE_FILTERS_KEY,
  FAQ_FILTERS_KEY,
  TEMPLATE_FILTERS_KEY,
]

export const CLINIC_DEFAULT_FILTERS: { clinic: ClinicType | undefined } = {
  clinic: undefined,
}

export const PATIENTS_DEFAULT_FILTERS: PatientFilterType = {
  columnVisibility: undefined,
  columnOrder: ['first_name', 'status', 'email', 'website_id', 'latest_activity', 'updated_at'],
}

export const PJ_DEFAULT_FILTERS: PatientsJourneysFilterType = {
  columnVisibility: undefined,
  columnOrder: ['procedures', 'status', 'patient', 'provider', 'coordinator', 'created_at', 'updated_at'],
}

export const FEED_DEFAULT_FILTERS: FeedFilterType = {
  selectedTypes: Object.values(FeedTypeEnum) as FeedTypeEnum[],
  selectedWebsites: [],
  created_at: undefined,
}

export const MESSAGE_DEFAULT_FILTERS: MessagesFilterType = {
  search: undefined,
  isNew: undefined,
  selectedWebsites: [],
}

export const LEAD_DEFAULT_FILTERS: LeadFilterType = {
  search: undefined,
  archived: undefined,
  selectedWebsites: [],
  selectedStatuses: [],
  selectedTypes: [],
  columnVisibility: {
    Website: false,
    Source: false,
  },
  columnOrder: ['type', 'name', 'message', 'email', 'source', 'Website', 'created_at', 'Actions'],
}

export const INVOICE_DEFAULT_FILTERS: InvoiceFilterType = {
  archived: undefined,
  status: [],
  created_at: undefined,
  columnVisibility: undefined,
  columnOrder: ['total', 'status', 'number', 'recipient', 'due_at', 'created_at'],
}

export const PROPOSAL_DEFAULT_FILTERS: ProposalFilterType = {
  archived: undefined,
  expired: undefined,
  expiring_soon: undefined,
  has_sections: undefined,
  status: PROPOSAL_DEFAULT_STATUSES,
  columnVisibility: undefined,
  columnOrder: ['title', 'status', 'number', 'recipient', 'sent_at', 'expires_at', 'created_at'],
}

export const IMPORT_DEFAULT_FILTERS: ImportFilterType = {
  type: undefined,
  columnVisibility: undefined,
  columnOrder: ['original_filename', 'status', 'type', 'updated_at'],
}

export const FAQ_DEFAULT_FILTERS: { active?: boolean | undefined } = {
  active: undefined,
}
